// import { SlatSize } from '../components/ProductBuilder/Section';
// import { BaseProductVariant, ProductBuilderMachineContext } from '../types';
// import { getVariantOptionKeyForBladeSize } from './bladeSize';
// import { getVariantOptionKeyForCellDesign } from './cellDesign';
// import { getBaseProduct, getBaseProductRollerNight } from './getBaseProduct';
// import { getVariantOptionKeyForBreakpoint } from './getVariantOptionKeyForBreakpoint';
// import { isCurtain, isSheer } from './isCurtain';
// import { isRollerDayNight } from './isRollerDayNight';
// import { isRollerEssentials } from './isRollerEssentials';
// import { isRollerSingle } from './isRollerSingle';
// import { isRomanBlinds } from './isRomanBlinds';
// import { isShutters } from './isShutters';
// import { isVenetianBlinds } from './isVenetianBlinds';
// import { getVariantOptionKeyForLining } from './lining';
// import { getVariantOptionKeyForMaterial } from './material';
// import { getVariantOptionKeyForMaterialTypeDay } from './materialTypeDay';
// import { getVariantOptionKeyForMaterialTypeNight } from './materialTypeNight';
// import { getVariantOptionKeyForOperation } from './operation';
// import { getVariantOptionKeyForPleatType } from './pleatType';
// import { getVariantOptionKeyForSlatSize } from './slatSize';

// type GetCurrentVariant = (
//   context: ProductBuilderMachineContext,
// ) => BaseProductVariant | void;

// const getCurrentVariantDefault: GetCurrentVariant = context => {
//   const {
//     custom: { materialType, cellDesign },
//   } = context;
//   const baseProduct = getBaseProduct(context);
//   if (!baseProduct) return;

//   const materialKey = getVariantOptionKeyForMaterial(baseProduct);
//   const cellDesignKey = getVariantOptionKeyForCellDesign(baseProduct);
//   let variants: BaseProductVariant[] = baseProduct.variants;

//   if (materialKey && materialType) {
//     variants = variants.filter(
//       variant => variant[materialKey] === materialType,
//     );
//   }

//   if (cellDesign && cellDesignKey) {
//     variants = variants.filter(
//       variant => variant[cellDesignKey] === cellDesign,
//     );
//   }

//   if (materialKey === null && cellDesignKey === null) return;
//   return variants[0];
// };

// const getCurrentVariantRollerSingle: GetCurrentVariant = context => {
//   const {
//     custom: { materialType },
//   } = context;

//   const measurements: string | undefined = context.custom.measurements;
//   let [width, height] =
//     typeof measurements === 'string'
//       ? measurements.split('x').map(value => parseInt(value))
//       : '0x0'.split('x').map(value => parseInt(value));

//   const baseProduct = getBaseProduct(context);
//   if (!baseProduct) return;

//   const materialKey = getVariantOptionKeyForMaterialTypeDay(baseProduct);
//   const breakpointKey = getVariantOptionKeyForBreakpoint(baseProduct);
//   const rollerBlindSquareMetreSize = (width * height) / 1000000;

//   const breakpointType =
//     rollerBlindSquareMetreSize <= 1.2
//       ? 'Breakpoint1'
//       : rollerBlindSquareMetreSize > 1.2 && rollerBlindSquareMetreSize <= 1.5
//       ? 'Breakpoint2'
//       : rollerBlindSquareMetreSize > 1.5 && rollerBlindSquareMetreSize <= 1.8
//       ? 'Breakpoint3'
//       : rollerBlindSquareMetreSize > 1.8 && rollerBlindSquareMetreSize <= 2.2
//       ? 'Breakpoint4'
//       : rollerBlindSquareMetreSize > 2.2
//       ? 'Breakpoint5'
//       : 'Breakpoint5';

//   if (materialKey === null || breakpointKey === null) return;

//   let variants: BaseProductVariant[] = baseProduct.variants;

//   if (materialType && materialKey) {
//     variants = variants.filter(
//       variant => variant[materialKey] === materialType,
//     );
//   }

//   if (breakpointType && breakpointKey) {
//     variants = variants.filter(
//       variant => variant[breakpointKey] === breakpointType,
//     );
//   }
//   if (materialKey === null && materialType === null) return;

//   return variants[0];
// };

// const getCurrentVariantRollerDay: GetCurrentVariant = context => {
//   const {
//     custom: { materialTypeDay },
//   } = context;

//   const measurements: string | undefined = context.custom.measurements;
//   let [width, height] =
//     typeof measurements === 'string'
//       ? measurements.split('x').map(value => parseInt(value))
//       : '0x0'.split('x').map(value => parseInt(value));
//   const baseProduct = getBaseProduct(context);
//   if (!baseProduct) return;

//   const materialDayKey = getVariantOptionKeyForMaterialTypeDay(baseProduct);
//   const breakpointKey = getVariantOptionKeyForBreakpoint(baseProduct);
//   const rollerBlindSquareMetreSize = (width * height) / 1000000;

//   const breakpointType =
//     rollerBlindSquareMetreSize <= 1.2
//       ? 'Breakpoint1'
//       : rollerBlindSquareMetreSize > 1.2 && rollerBlindSquareMetreSize <= 1.5
//       ? 'Breakpoint2'
//       : rollerBlindSquareMetreSize > 1.5 && rollerBlindSquareMetreSize <= 1.8
//       ? 'Breakpoint3'
//       : rollerBlindSquareMetreSize > 1.8 && rollerBlindSquareMetreSize <= 2.2
//       ? 'Breakpoint4'
//       : rollerBlindSquareMetreSize > 2.2
//       ? 'Breakpoint5'
//       : 'Breakpoint5';
//   if (materialDayKey === null) return;

//   let variants: BaseProductVariant[] = baseProduct.variants;

//   if (materialTypeDay && materialDayKey) {
//     variants = variants.filter(
//       variant => variant[materialDayKey] === materialTypeDay,
//     );
//   }

//   if (breakpointType && breakpointKey) {
//     variants = variants.filter(
//       variant => variant[breakpointKey] === breakpointType,
//     );
//   }

//   if (materialDayKey === null && materialTypeDay === null) return;
//   return variants[0];
// };

// export const getCurrentVariantRollerNight: GetCurrentVariant = context => {
//   const {
//     custom: { materialTypeNight },
//   } = context;
//   const measurements: string | undefined = context.custom.measurements;
//   let [width, height] =
//     typeof measurements === 'string'
//       ? measurements.split('x').map(value => parseInt(value))
//       : '0x0'.split('x').map(value => parseInt(value));
//   const baseProduct = getBaseProductRollerNight(context);
//   if (!baseProduct) return;
//   const materialNightKey = getVariantOptionKeyForMaterialTypeDay(baseProduct);
//   const breakpointKey = getVariantOptionKeyForBreakpoint(baseProduct);
//   const rollerBlindSquareMetreSize = (width * height) / 1000000;

//   const breakpointType =
//     rollerBlindSquareMetreSize <= 1.2
//       ? 'Breakpoint1'
//       : rollerBlindSquareMetreSize > 1.2 && rollerBlindSquareMetreSize <= 1.5
//       ? 'Breakpoint2'
//       : rollerBlindSquareMetreSize > 1.5 && rollerBlindSquareMetreSize <= 1.8
//       ? 'Breakpoint3'
//       : rollerBlindSquareMetreSize > 1.8 && rollerBlindSquareMetreSize <= 2.2
//       ? 'Breakpoint4'
//       : rollerBlindSquareMetreSize > 2.2
//       ? 'Breakpoint5'
//       : 'Breakpoint5';
//   if (materialNightKey === null) return;
//   let variants: BaseProductVariant[] = baseProduct.variants;

//   if (materialTypeNight && materialNightKey) {
//     variants = variants.filter(
//       variant => variant[materialNightKey] === materialTypeNight,
//     );
//   }

//   if (breakpointType && breakpointKey) {
//     variants = variants.filter(
//       variant => variant[breakpointKey] === breakpointType,
//     );
//   }

//   if (materialNightKey === null && materialTypeNight === null) return;
//   return variants[0];
// };

// const getCurrentVariantShutter: GetCurrentVariant = context => {
//   const {
//     custom: { bladeSize, operation },
//   } = context;
//   const baseProduct = getBaseProduct(context);
//   if (!baseProduct) return;

//   const bladeSizeKey = getVariantOptionKeyForBladeSize(baseProduct);
//   const operationKey = getVariantOptionKeyForOperation(baseProduct);
//   if (bladeSizeKey === null || operationKey === null) return;

//   let variants: BaseProductVariant[] = baseProduct.variants;

//   if (bladeSizeKey && bladeSize) {
//     variants = variants.filter(variant => variant[bladeSizeKey] === bladeSize);
//   }

//   if (operationKey && operation) {
//     variants = variants.filter(variant => variant[operationKey] === operation);
//   }

//   if (operationKey === null && bladeSizeKey === null) return;
//   return variants[0];
// };

// const getCurrentVariantVenetianBlinds: GetCurrentVariant = context => {
//   const {
//     custom: { slatSize },
//   } = context;
//   const baseProduct = getBaseProduct(context);
//   if (!baseProduct) return;

//   const slatSizeKey = getVariantOptionKeyForSlatSize(baseProduct);
//   if (slatSizeKey === null) return;

//   let variants: BaseProductVariant[] = baseProduct.variants;

//   if (slatSizeKey && slatSize) {
//     variants = variants.filter(variant => variant[slatSizeKey] === slatSize);
//   }

//   if (slatSizeKey === null) return;
//   return variants[0];
// };

// const getCurrentVariantRomanBlinds: GetCurrentVariant = context => {
//   const {
//     custom: { lining },
//   } = context;
//   const baseProduct = getBaseProduct(context);
//   if (!baseProduct) return;

//   const liningKey = getVariantOptionKeyForLining(baseProduct);

//   let variants: BaseProductVariant[] = baseProduct.variants;

//   if (liningKey && lining) {
//     variants = variants.filter(variant => variant[liningKey] === lining);
//   }

//   if (liningKey === null) return;
//   return variants[0];
// };

// const getCurrentVariantCurtain: GetCurrentVariant = context => {
//   const {
//     custom: { lining, pleatType },
//   } = context;
//   const baseProduct = getBaseProduct(context);
//   if (!baseProduct) return;
//   // Sheer is now in the curtain collection, so just check if it's sheer, if it is set it to the only
//   // lining option for sheer
//   // let liningOption = baseProduct.type === 'Sheer Curtain' ? 'Unlined' : lining;
//   let liningOption = lining;
//   const liningKey = getVariantOptionKeyForLining(baseProduct);
//   const PleatTypeKey = getVariantOptionKeyForPleatType(baseProduct);

//   let variants: BaseProductVariant[] = baseProduct.variants;
//   if (liningKey === null || PleatTypeKey === null) return;
  
//   // if (liningKey && liningOption) {
//   //   variants = variants.filter(variant => variant[liningKey] === liningOption);
//   // }
  
//   // if (PleatTypeKey && pleatType) {
//   //   variants = variants.filter(variant => variant[PleatTypeKey] === pleatType);
//   // }
  
//   if (PleatTypeKey === null && liningKey === null) return;
//   return variants[0];
// };

// // Leaving this here for when the sheer collection comes back
// const getCurrentVariantSheer: GetCurrentVariant = context => {
//   const {
//     custom: { pleatType },
//   } = context;
//   const baseProduct = getBaseProduct(context);
//   if (!baseProduct) return;

//   const PleatTypeKey = getVariantOptionKeyForPleatType(baseProduct);
//   if (PleatTypeKey === null) return;

//   return baseProduct.variants.find(
//     variant => variant[PleatTypeKey] === pleatType,
//   );
// };

// export const getCurrentVariant: GetCurrentVariant = context => {
//   const baseProduct = getBaseProduct(context);
//   if (!baseProduct) return;
//   if (isRollerSingle(context)) return getCurrentVariantRollerSingle(context);
//   if (isRollerEssentials(context))
//     return getCurrentVariantRollerSingle(context);
//   if (isRollerDayNight(context)) return getCurrentVariantRollerDay(context);
//   if (isShutters(context)) return getCurrentVariantShutter(context);
//   if (isVenetianBlinds(context))
//     return getCurrentVariantVenetianBlinds(context);
//   if (isRomanBlinds(context)) return getCurrentVariantRomanBlinds(context);
//   // Comment out isSheer until the sheer collection comes back
//   if (isSheer(context)) return getCurrentVariantCurtain(context);
//   if (isCurtain(context)) return getCurrentVariantCurtain(context);
//   return getCurrentVariantDefault(context);
// };


import { SlatSize } from '../components/ProductBuilder/Section';
import { BaseProductVariant, ProductBuilderMachineContext } from '../types';
import { getVariantOptionKeyForBladeSize } from './bladeSize';
import { getVariantOptionKeyForCellDesign } from './cellDesign';
import { getBaseProduct, getBaseProductRollerNight } from './getBaseProduct';
import { getVariantOptionKeyForBreakpoint } from './getVariantOptionKeyForBreakpoint';
import { isCurtain, isSheer } from './isCurtain';
import { isRollerDayNight } from './isRollerDayNight';
import { isRollerEssentials } from './isRollerEssentials';
import { isRollerSingle } from './isRollerSingle';
import { isRomanBlinds } from './isRomanBlinds';
import { isShutters } from './isShutters';
import { isVenetianBlinds } from './isVenetianBlinds';
import { getVariantOptionKeyForLining } from './lining';
import { getVariantOptionKeyForMaterial } from './material';
import { getVariantOptionKeyForMaterialTypeDay } from './materialTypeDay';
import { getVariantOptionKeyForMaterialTypeNight } from './materialTypeNight';
import { getVariantOptionKeyForOperation } from './operation';
import { getVariantOptionKeyForPleatType } from './pleatType';
import { getVariantOptionKeyForSlatSize } from './slatSize';

type GetCurrentVariant = (
  context: ProductBuilderMachineContext,
) => BaseProductVariant | void;

const getCurrentVariantDefault: GetCurrentVariant = context => {
  const {
    custom: { materialType, cellDesign },
  } = context;
  const baseProduct = getBaseProduct(context);
  if (!baseProduct) return;

  const materialKey = getVariantOptionKeyForMaterial(baseProduct);
  const cellDesignKey = getVariantOptionKeyForCellDesign(baseProduct);
  let variants: BaseProductVariant[] = baseProduct.variants;

  if (materialKey && materialType) {
    variants = variants.filter(
      variant => (variant as any)[materialKey] === materialType,
    );
  }

  if (cellDesign && cellDesignKey) {
    variants = variants.filter(
      variant => (variant as any)[cellDesignKey] === cellDesign,
    );
  }

  if (materialKey === null && cellDesignKey === null) return;
  return variants[0];
};

const getCurrentVariantRollerSingle: GetCurrentVariant = context => {
  const {
    custom: { materialType },
  } = context;

  const measurements: string | undefined = context.custom.measurements;
  let [width, height] =
    typeof measurements === 'string'
      ? measurements.split('x').map(value => parseInt(value))
      : '0x0'.split('x').map(value => parseInt(value));

  const baseProduct = getBaseProduct(context);
  if (!baseProduct) return;

  const materialKey = getVariantOptionKeyForMaterialTypeDay(baseProduct);
  const breakpointKey = getVariantOptionKeyForBreakpoint(baseProduct);
  const rollerBlindSquareMetreSize = (width * height) / 1000000;

  const breakpointType =
    rollerBlindSquareMetreSize <= 1.2
      ? 'Breakpoint1'
      : rollerBlindSquareMetreSize > 1.2 && rollerBlindSquareMetreSize <= 1.5
      ? 'Breakpoint2'
      : rollerBlindSquareMetreSize > 1.5 && rollerBlindSquareMetreSize <= 1.8
      ? 'Breakpoint3'
      : rollerBlindSquareMetreSize > 1.8 && rollerBlindSquareMetreSize <= 2.2
      ? 'Breakpoint4'
      : rollerBlindSquareMetreSize > 2.2
      ? 'Breakpoint5'
      : 'Breakpoint5';

  if (materialKey === null || breakpointKey === null) return;

  let variants: BaseProductVariant[] = baseProduct.variants;

  if (materialType && materialKey) {
    variants = variants.filter(
      variant => (variant as any)[materialKey] === materialType,
    );
  }

  if (breakpointType && breakpointKey) {
    variants = variants.filter(
      variant => (variant as any)[breakpointKey] === breakpointType,
    );
  }
  if (materialKey === null && materialType === null) return;

  return variants[0];
};

const getCurrentVariantRollerDay: GetCurrentVariant = context => {
  const {
    custom: { materialTypeDay },
  } = context;

  const measurements: string | undefined = context.custom.measurements;
  let [width, height] =
    typeof measurements === 'string'
      ? measurements.split('x').map(value => parseInt(value))
      : '0x0'.split('x').map(value => parseInt(value));
  const baseProduct = getBaseProduct(context);
  if (!baseProduct) return;

  const materialDayKey = getVariantOptionKeyForMaterialTypeDay(baseProduct);
  const breakpointKey = getVariantOptionKeyForBreakpoint(baseProduct);
  const rollerBlindSquareMetreSize = (width * height) / 1000000;

  const breakpointType =
    rollerBlindSquareMetreSize <= 1.2
      ? 'Breakpoint1'
      : rollerBlindSquareMetreSize > 1.2 && rollerBlindSquareMetreSize <= 1.5
      ? 'Breakpoint2'
      : rollerBlindSquareMetreSize > 1.5 && rollerBlindSquareMetreSize <= 1.8
      ? 'Breakpoint3'
      : rollerBlindSquareMetreSize > 1.8 && rollerBlindSquareMetreSize <= 2.2
      ? 'Breakpoint4'
      : rollerBlindSquareMetreSize > 2.2
      ? 'Breakpoint5'
      : 'Breakpoint5';
  if (materialDayKey === null) return;

  let variants: BaseProductVariant[] = baseProduct.variants;

  if (materialTypeDay && materialDayKey) {
    variants = variants.filter(
      variant => (variant as any)[materialDayKey] === materialTypeDay,
    );
  }

  if (breakpointType && breakpointKey) {
    variants = variants.filter(
      variant => (variant as any)[breakpointKey] === breakpointType,
    );
  }

  if (materialDayKey === null && materialTypeDay === null) return;
  return variants[0];
};

export const getCurrentVariantRollerNight: GetCurrentVariant = context => {
  const {
    custom: { materialTypeNight },
  } = context;
  const measurements: string | undefined = context.custom.measurements;
  let [width, height] =
    typeof measurements === 'string'
      ? measurements.split('x').map(value => parseInt(value))
      : '0x0'.split('x').map(value => parseInt(value));
  const baseProduct = getBaseProductRollerNight(context);
  if (!baseProduct) return;
  const materialNightKey = getVariantOptionKeyForMaterialTypeDay(baseProduct);
  const breakpointKey = getVariantOptionKeyForBreakpoint(baseProduct);
  const rollerBlindSquareMetreSize = (width * height) / 1000000;

  const breakpointType =
    rollerBlindSquareMetreSize <= 1.2
      ? 'Breakpoint1'
      : rollerBlindSquareMetreSize > 1.2 && rollerBlindSquareMetreSize <= 1.5
      ? 'Breakpoint2'
      : rollerBlindSquareMetreSize > 1.5 && rollerBlindSquareMetreSize <= 1.8
      ? 'Breakpoint3'
      : rollerBlindSquareMetreSize > 1.8 && rollerBlindSquareMetreSize <= 2.2
      ? 'Breakpoint4'
      : rollerBlindSquareMetreSize > 2.2
      ? 'Breakpoint5'
      : 'Breakpoint5';
  if (materialNightKey === null) return;
  let variants: BaseProductVariant[] = baseProduct.variants;

  if (materialTypeNight && materialNightKey) {
    variants = variants.filter(
      variant => (variant as any)[materialNightKey] === materialTypeNight,
    );
  }

  if (breakpointType && breakpointKey) {
    variants = variants.filter(
      variant => (variant as any)[breakpointKey] === breakpointType,
    );
  }

  if (materialNightKey === null && materialTypeNight === null) return;
  return variants[0];
};

const getCurrentVariantShutter: GetCurrentVariant = context => {
  const {
    custom: { bladeSize, operation },
  } = context;
  const baseProduct = getBaseProduct(context);
  if (!baseProduct) return;

  const bladeSizeKey = getVariantOptionKeyForBladeSize(baseProduct);
  const operationKey = getVariantOptionKeyForOperation(baseProduct);
  if (bladeSizeKey === null || operationKey === null) return;

  let variants: BaseProductVariant[] = baseProduct.variants;

  if (bladeSizeKey && bladeSize) {
    variants = variants.filter(variant => (variant as any)[bladeSizeKey] === bladeSize);
  }

  if (operationKey && operation) {
    variants = variants.filter(variant => (variant as any)[operationKey] === operation);
  }

  if (operationKey === null && bladeSizeKey === null) return;
  return variants[0];
};

const getCurrentVariantVenetianBlinds: GetCurrentVariant = context => {
  const {
    custom: { slatSize },
  } = context;
  const baseProduct = getBaseProduct(context);
  if (!baseProduct) return;

  const slatSizeKey = getVariantOptionKeyForSlatSize(baseProduct);
  if (slatSizeKey === null) return;

  let variants: BaseProductVariant[] = baseProduct.variants;

  if (slatSizeKey && slatSize) {
    variants = variants.filter(variant => (variant as any)[slatSizeKey] === slatSize);
  }

  if (slatSizeKey === null) return;
  return variants[0];
};

const getCurrentVariantRomanBlinds: GetCurrentVariant = context => {
  const {
    custom: { lining },
  } = context;
  const baseProduct = getBaseProduct(context);
  if (!baseProduct) return;

  const liningKey = getVariantOptionKeyForLining(baseProduct);

  let variants: BaseProductVariant[] = baseProduct.variants;

  if (liningKey && lining) {
    variants = variants.filter(variant => (variant as any)[liningKey] === lining);
  }

  if (liningKey === null) return;
  return variants[0];
};

// 🚨 CRITICAL FIX: Enhanced curtain variant function with detailed debugging
const getCurrentVariantCurtain: GetCurrentVariant = context => {
  const {
    custom: { lining, pleatType },
  } = context;


  const baseProduct = getBaseProduct(context);
  if (!baseProduct) {
    return;
  }
  
  const liningKey = getVariantOptionKeyForLining(baseProduct);
  const PleatTypeKey = getVariantOptionKeyForPleatType(baseProduct);



  let variants: BaseProductVariant[] = baseProduct.variants;
  
  // Early return if no keys found
  if (!liningKey && !PleatTypeKey) {
    return baseProduct.variants[0];
  }
  
  // 🔍 STEP 1: Filter by pleat type
  if (PleatTypeKey && pleatType) {
    const beforeCount = variants.length;
    
    variants = variants.filter(variant => {
      const variantValue = (variant as any)[PleatTypeKey];
      const matches = variantValue === pleatType;
      return matches;
    });
    
    
    if (variants.length === 0) {
      console.error(`❌ CRITICAL: No variants found for pleat type "${pleatType}"`);
     
      // Don't return here, continue to see if lining filter helps
      variants = baseProduct.variants; // Reset for lining filter
    }
  }
  
  // 🔍 STEP 2: Filter by lining
  if (liningKey && lining) {
    const beforeCount = variants.length;
    
    const liningFiltered = variants.filter(variant => {
      const variantValue = (variant as any)[liningKey];
      const matches = variantValue === lining;
      return matches;
    });
    
    
    if (liningFiltered.length === 0) {
      console.error(`❌ CRITICAL: No variants found for lining "${lining}"`);
    } else {
      variants = liningFiltered;
    }
  }

  // 🔍 STEP 3: Try combined filter if both filters individually failed
  if (variants.length === 0 && PleatTypeKey && pleatType && liningKey && lining) {
    
    variants = baseProduct.variants.filter(variant => {
      const pleatMatch = (variant as any)[PleatTypeKey] === pleatType;
      const liningMatch = (variant as any)[liningKey] === lining;
      const bothMatch = pleatMatch && liningMatch;
      
      
      return bothMatch;
    });
    
  }
  
  // 🎯 FINAL RESULT
  if (variants.length === 0) {
    console.error('❌ FINAL: No variants found with any combination, falling back to first variant');
    

    
    return baseProduct.variants[0];
  }
  
  const selectedVariant = variants[0];
  
  return selectedVariant;
};

// Leaving this here for when the sheer collection comes back
const getCurrentVariantSheer: GetCurrentVariant = context => {
  const {
    custom: { pleatType },
  } = context;
  const baseProduct = getBaseProduct(context);
  if (!baseProduct) return;

  const PleatTypeKey = getVariantOptionKeyForPleatType(baseProduct);
  if (PleatTypeKey === null) return;

  return baseProduct.variants.find(
    variant => (variant as any)[PleatTypeKey] === pleatType,
  );
};

export const getCurrentVariant: GetCurrentVariant = context => {

  const baseProduct = getBaseProduct(context);
  if (!baseProduct) return;
  
  if (isRollerSingle(context)) return getCurrentVariantRollerSingle(context);
  if (isRollerEssentials(context))
    return getCurrentVariantRollerSingle(context);
  if (isRollerDayNight(context)) return getCurrentVariantRollerDay(context);
  if (isShutters(context)) return getCurrentVariantShutter(context);
  if (isVenetianBlinds(context))
    return getCurrentVariantVenetianBlinds(context);
  if (isRomanBlinds(context)) return getCurrentVariantRomanBlinds(context);
  // Comment out isSheer until the sheer collection comes back
  if (isSheer(context)) return getCurrentVariantCurtain(context);
  if (isCurtain(context)) return getCurrentVariantCurtain(context);
  return getCurrentVariantDefault(context);
};
